import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import {countBy} from 'lodash';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import {IsCordovaApp, IsStringValid} from "../../constants";
import {apiPost} from '../../utils/request';

export const NewAddress = (count) => {
  return {
    id: (-1 - count),
    line1: '',
    line2: '',
    suburbName: '',
    postCode: '',
    state: '',
    isPrimary: false,
    addressType: ''
  };
};

class AddressView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      address: props.address,
      states: [{value: 'NSW', label: 'NSW'},{value: 'ACT', label: 'ACT'},{value: 'QLD', label: 'QLD'},{value: 'SA', label: 'SA'},{value: 'TAS', label: 'TAS'},{value: 'VIC', label: 'VIC'},{value: 'WA', label: 'WA'},{value: 'NT', label: 'NT'}],
      addressTypes: [
        {value: 'Business Registered', label: 'Business Registered'},
        {value: 'Home', label: 'Home'},
        {value: 'Work', label: 'Work'},
        {value: 'Location', label: 'Location'},
      ],
    };

    this.handleSaveAddress = this.handleSaveAddress.bind(this);
    this.handleCancelAddress = this.handleCancelAddress.bind(this);
    this.handleAddressStateFieldChange = this.handleAddressStateFieldChange.bind(this);
    this.handleAddressFieldChange = this.handleAddressFieldChange.bind(this);
    this.validateAddress = this.validateAddress.bind(this);
    this.handleAddressTypeFieldChange = this.handleAddressTypeFieldChange.bind(this);
    this.handleViewAddress = this.handleViewAddress.bind(this);
    this.handleLookupAddress = this.handleLookupAddress.bind(this);
  }


  handleAddressStateFieldChange(val){
    this.setState({address: {...this.state.address, state: val, latitude: null, longitude: null}});
  }

  handleAddressTypeFieldChange(val){
    this.setState({address: {...this.state.address, addressType: val}});
  }

  componentDidUpdate(prevProps){
    if(!this.state.address || this.props.address.id !== prevProps.address.id){
      this.setState({address: this.props.address});
    }
  }

  handleAddressFieldChange(e){
    let x = {...this.state.address};
    if(e.target.type==='checkbox'){
      x[`${e.target.name}`] = e.target.checked;
    } else {
      x[`${e.target.name}`] = e.target.value;
      x.latitude = null;
      x.longitude = null;
    }

    this.setState({address: x});
  }
  
  handleSaveAddress() {
    this.props.onComplete(this.state.address);
  }

  validateAddress(){
    let {address} = this.state;

    if(address){
      if(
        address.addressType === '' ||
        address.line1.trim() === '' ||
        address.suburbName.trim() === '' ||
        address.postCode.trim() === '' ||
        address.state === null || address.state === ''){
        return {valid: false, error: ''};
      } else if (address.latitude === null || address.longitude === null){
        return {valid: false, error: 'Address not verified, please use lookup button '};
      }
    }
    return {valid: true, error: ''};
  }

  handleCancelAddress(){
    if(this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleViewAddress(){
    let {address} = this.state;
    if(IsCordovaApp()){
      window.open(`geo://0,0?q=${address.latitude},${address.longitude}(${encodeURI(address.line1)})`, '_system', 'location=yes');
    } else {
      window.open(`https://www.google.com/maps/search/?api=1&query=${address.latitude},${address.longitude}`, '_blank');
    }
  }

  handleLookupAddress() {
    return apiPost('/api/addresses/reversegeocode', this.state.address)
      .then(x => {
        if (!x.error) {
          let {address} = this.state;
          this.setState({
            address: {
              ...x.data,
              id: address.id,
              addressType: address.addressType,
              migratedFrom: address.migratedFrom,
              isPrimary: address.isPrimary,
            }
          });
        } else {
          toastr.warning('Address not found');
        }
      });
  }

  render(){
    const isValidAddress = this.validateAddress();
    let {address} = this.state;

    return address ? (
      <div>
        { this.props.enableAddressType && <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="addressType">Address Type</label>
            <div className="col-md-8">
              <Select
                name="addressType"
                value={address.addressType}
                multi={false}
                simpleValue
                options={this.state.addressTypes}
                onChange={this.handleAddressTypeFieldChange}
                clearable={false}
                deleteRemoves={false}
              />
            </div>
          </div> }
          <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="line1">Line 1</label>
            <div className="col-md-8">
              <Input type="text"
                     value={address.line1}
                     onChange={this.handleAddressFieldChange}
                     name="line1"
                     placeholder="Address Line 2"
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="line2">Line 2</label>
            <div className="col-md-8">
              <Input type="text"
                     value={address.line2}
                     onChange={this.handleAddressFieldChange}
                     name="line2"
                     placeholder="Address Line 2"
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="suburbName">Suburb</label>
            <div className="col-md-6">
              <Input type="text"
                     value={address.suburbName}
                     onChange={this.handleAddressFieldChange}
                     name="suburbName"
                     placeholder="Suburb"
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="postCode">Post Code</label>
            <div className="col-md-4">
              <Input type="text"
                     value={address.postCode}
                     onChange={this.handleAddressFieldChange}
                     name="postCode"
                     placeholder="Post Code"
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="state">State</label>
            <div className="col-md-4">
              <Select
                name="state"
                value={address.state}
                multi={false}
                simpleValue
                options={this.state.states}
                onChange={this.handleAddressStateFieldChange}
                clearable={false}
                deleteRemoves={false}
              />
            </div>
          </div>
          { this.props.enableIsPrimary && <div className="form-group row">
            <label className="col-md-2 form-control-label"  htmlFor="isPrimary">Is Primary</label>
            <div className="col-md-8">
              <FormGroup check>
                <Label check>
                  <Input type="checkbox"
                         className="checkbox-control"
                         checked={address.isPrimary}
                         onChange={this.handleAddressFieldChange}
                         name="isPrimary"
                  />
                </Label>
              </FormGroup>
            </div>
          </div> }
          {address.id > 0 && address.migratedFrom &&
          <div className="form-group row">
            <label className="col-md-2 form-control-label">Imported address</label>
            <div className="col-md-8">{address.migratedFrom}</div>
          </div>}
          <div className="form-group row">
            <div className="offset-md-2 col-md-8">
                <Button color="success" onClick={this.handleLookupAddress} style={{marginRight: '10px'}}><i className="fa fa-search"/>&nbsp;Verify
                </Button>
              {(address.latitude && address.longitude) &&
              <Button color="primary" onClick={this.handleViewAddress}><i className="fa fa-map-marker"/>&nbsp;Map</Button>
              }
            </div>
          </div>

          <div className="form-group row">
            <div className="offset-md-2 col-md-8">
              {isValidAddress.valid ?
                <Button color="primary" onClick={this.handleSaveAddress} style={{marginRight: '10px'}}><i className="fa fa-check"/>&nbsp;
                </Button> :
                <span className="text-danger">{isValidAddress.error}</span>
              }
              {this.props.onCancel && <Button color="seconday" onClick={this.handleCancelAddress}><i className="fa fa-mail-reply" />&nbsp;</Button> }
            </div>
          </div>
        </div>

    ) : null;
  }
}

AddressView.propTypes = {
  address: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  enableDelete: PropTypes.bool,
  enableIsPrimary: PropTypes.bool,
  enableAddressType: PropTypes.bool,
};

AddressView.defatultProps = {
  addresses: [],
  enableDelete: true,
  enableIsPrimary: true,
  enableAddressType: true,
};

export default AddressView;